module.exports = __webpack_public_path__ + "static/media/neel-main.1f0de29b.png";